import api from '../../api/index';

export default {
  namespaced: true,
  state     : {
    themes        : ['Все темы', 'База знаний', 'Обучение', 'Профиль', 'Новости и мероприятия'],
    question_modal: false,
    list          : [

    ],
    selected_theme : null,
    selected_number: 10,
    selected_page  : 1,
    search_string  : '',
  },
  getters: {
    list           : ({list}) => list,
    last_question  : ({list}) => list[list.length-1],
    themes         : ({themes}) => themes,
    question_modal : ({question_modal}) => question_modal,
    selected_theme : ({selected_theme}) => selected_theme,
    selected_number: ({selected_number}) => selected_number,
    selected_page  : ({selected_page}) => selected_page,
    search_string  : ({search_string}) => search_string,
    filtered_by_theme({list}, {selected_theme}) {
      if (selected_theme) {
        return list.filter((item)=> item.theme == selected_theme);
      } else {
        return list;
      }
    },
    search_by_string: ({selected_theme, list, search_string}, {filtered_by_theme})=> {
      if (selected_theme) {
        return filtered_by_theme.filter((x)=> x.title.toLowerCase().includes(search_string.toLowerCase()));
      } else {
        return list.filter((x)=> x.title.toLowerCase().includes(search_string.toLowerCase()));
      }
    },
    paginated({search_string}, {selected_number, filtered_by_theme, selected_page, search_by_string}) {
      if (search_string) {
        return search_by_string.slice((selected_number*(selected_page-1)), selected_number*selected_page);
      } else {
        return filtered_by_theme.slice((selected_number*(selected_page-1)), selected_number*selected_page);
      }
    },

  },
  mutations: {
    CLOSE_MODAL(state) {
      state.question_modal = false;
    },
    OPEN_MODAL(state) {
      if (!state.question_modal) {
        state.question_modal = true;
      }
    },
    SET_SELECTED_THEME(state, value) {
      state.selected_theme = value;
    },
    SET_SELECTED_PAGE(state, value) {
      state.selected_page = value;
    },
    SHOW_NUMBER(state, obj) {
      const {array, selected} = obj;
      if (selected=='Показывать по 10') {
        state.selected_number = 10;
      } else if (selected=='Показывать по 25') {
        state.selected_number = 25;
      } else if (selected=='Показывать по 50') {
        state.selected_number = 50;
      } else if (selected=='Показывать по 100') {
        state.selected_number = 100;
      }
      if (array.length >= 10) {
        return array.slice(0, state.selected_number);
      } else {
        return array;
      }
    },
    CLEAR_PAGES(state) {
      state.selected_page = 1;
    },
    SET_QUESTIONS(state, questions) {
      if (!questions.list) {
        state.list=[];
      } else {
        state.list = questions.list;
      }
      // state.themes = questions.themes;
    },
    SEARCH_STRING(state, value) {
      state.search_string = value;
      state.selected_page = 1;
    },
  },
  actions: {
    show_number({commit, getters}, event, number) {
      const {filtered_by_theme} = getters;
      commit('CLEAR_PAGES');
      commit('SHOW_NUMBER', {array: filtered_by_theme, selected: event});
    },
    ask_question({commit, getters, dispatch}, question) {
      const {last_question} = getters;
      let new_question = {
        id    : last_question.id + 1,
        title : question.question_text,
        status: 'processing',
        theme : question.question_theme,
        text  : 'Обрабатывается',
      };
      commit('contact/requests/SEND_QUESTION', {question: new_question}, {root: true});
      dispatch('post_faq_questions', new_question);
      commit('CLOSE_MODAL');
    },
    async get_faq_questions({commit}) {
      try {
        const faq_questions = await api.faq.get_faq_questions();
        commit('SET_QUESTIONS', faq_questions.data);
      } catch (err) {
        console.error(err);
      }
    },
    async post_faq_questions(new_question) {
      try {
        await api.feedback.post_faq_questions(new_question);
      } catch (err) {
        console.error(err);
      }
    },
  },
};

